<div class="tooltip-container" #container>
  <span
    [appendTo]="container"
    class="question-icon-container"
    pTooltip=" "
    tabindex="1"
    tooltipEvent="focus"
    tooltipPosition="{{ position }}"
    tooltipStyleClass="tooltip"
  >
    <fa-icon class="question-icon" [icon]="['fal', 'question-circle']"></fa-icon>
  </span>
</div>
